export default "<div class=\"bg-primary fixed-bottom text-center text-white p-2\">\n    <ng-content></ng-content>\n</div>\n";